/* eslint-disable valid-jsdoc */
/**
 *  素材库公共数据服务
 */
angular.module('resourceCenterMaterialModule').service('mrService', [
    'trsHttpService',
    '$q',
    'mediaTagApiService',
    'mrApiService',
    'materialConst',
    '$modal',
    'localStorageService',
    function (trsHttpService, $q, mediaTagApiService, mrApiService, materialConst, $modal, localStorageService) {

        let buttonList = {
            upload: ['upload'],
            uploadmeizi: ['uploadmeizi'],
            delete: ['delete'],
            edit: ['edit'],
            chakan: ['chakan'],
        };

        let btnRights = {};

        return {
            getBtnRights: getBtnRights, // 获取按钮权限
            loadTips: loadTips, // 加载标签
            addTag: addTag, // 输入事物标签时如果待选中没有则添加到待选中
            getMediaBasicStatus: getMediaBasicStatus, // 获取媒资功能通用基本参数
            newFile: newFile, // 初始化新建文件夹弹窗
            takeDoc: takeDoc // 媒资素材取稿到采编
        };

        /**
         * [getBtnRights 获取按钮权限]
         *
         * @param   {[type]}  mrtype        [mrtype description]
         * @param   {[type]}  resourceType  [resourceType description]
         *
         * @return  {[type]}                [return description]
         */
        function getBtnRights(mrtype, resourceType) {
            let deffered = $q.defer();
            let params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperKeysOfNormalModal',
                Classify: materialConst.classMap[mrtype] + '.' + materialConst.classifyMap[resourceType],
                ModalName: materialConst.modelNameMap[mrtype],
            };

            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((rights) => {
                btnRights = rights;
                let checklist = buttonListCheck(mrtype, resourceType);
                deffered.resolve(checklist);
            }, function(data){
                deffered.reject(data);
            });

            return deffered.promise;
        }

        /**
         * 处理按钮权限
         * @return  {[type]}  [return description]
         */
        function buttonListCheck(mrtype, resourceType) {
            // Object.keys 为了得出对象key的集合
            let getCheckList = btnRights;
            let checkList = Object.keys(buttonList);

            for (let i = 0; i < getCheckList.length; i++) {
                for (let l = 0; l < checkList.length; l++) {
                    let check = false;
                    for (let b = 0; b < buttonList[checkList[l]].length; b++) {
                        let checkKey = materialConst.classMap[mrtype] + '.' + materialConst.classifyMap[resourceType] + '.' + buttonList[checkList[l]][b];
                        if (checkKey === getCheckList[i].OPERNAME) {
                            checkList[checkList[l]] = true;
                            check = true;
                            break;
                        }
                    }
                    if (check) {
                        break;
                    }
                }
            }

            return checkList;
        }

        /**
         * [loadTips description] 加载标签（智能标签）
         *
         * @param   {[type]}  word  [word description]
         *
         * @return  {[type]}        [return description]
         */
        function loadTips($scope, word, type) {
            let deffer = $q.defer();
            if (!word) {
                deffer.resolve([]);
            }
            var params = {
                keyword: word,
                pageNum: 1,
                pageSize: 100,
                type: type,
            };
            $scope.loadingPromis = mediaTagApiService.getTagList(params).then(function(data){
                if (data.code === '200'){
                    deffer.resolve(data.datas);
                }
            });
            return deffer.promise;
        }

        /**
         * [addTag 手动输入智能标签时如果没有该标签则添加一个]
         *
         * @param   {[type]}  item  [data description]
         * @param   {[type]}  data  [data description]
         * @param   {[type]}  type  [type description]
         * @param   {[type]}  word  [word description]
         *
         * @return  {[type]}        [return description]
         */
        function addTag(item, data, type, word){
            if (type === 'event') {
                var sameName = false;
                for (var i = 0; i < data.length; i++) {
                    if (word === data[i].labelname) {
                        sameName = true;
                        break;
                    }
                }
                if (!sameName) {
                    item[type].push({
                        labelname: word,
                        id: '0',
                    });
                }
                return item;
            }
        }

        /**
         * [getMediaBasicStatus 获取媒资功能基本参数]
         *
         * @return  {[type]}  [return description]
         */
        function getMediaBasicStatus(){
            return {
                isWithFilters: false,
                showUpload: null,
                copyCurrPage: 1,
                isInFolder: false,
                currentFolderId: 0,
                screenWrapSelected: false,
                commonParams: {
                    mrType: 'personal',
                    mainResourceType: '2'
                },
                orderParams: {
                    sortBy: 'time',
                    sortOrder: 'desc',
                },
                searchParams: mrApiService.resetSearchparams(),
                indexParams: mrApiService.resetIndexParams(),
                folderSearchParams: mrApiService.resetFolderParams(),
            };
        }

        /**
         * [newOrRenameFile description]初始化新建文件弹窗
         *
         * @param   {[type]}  commonParams    [fileId description]
         *
         * @return  {[type]}            [return description]
         */
        function newFile(commonParams) {
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: './resourceCenter/materialResource/service/newFile/newOrRenameFile_tpl.html',
                windowClass: 'edit-iwo-personalMaterial-newOrRenameFile',
                backdrop: false,
                controller: 'newFileModuleCtrl',
                resolve: {
                    params: function () {
                        return {
                            commonParams,
                        };
                    },
                },
            });
            modalInstance.result.then(function (result) {
                defer.resolve(result);
            });
            return defer.promise;
        }

        /**
         * [takeDoc description] 取稿操作
         *
         * @param   {[type]}  relationId    [relationId description] 资源关联id
         * @param   {[type]}  commonParams  [commonParams description] 路径信息
         *
         * @return  {[type]}                [return description]
         */
        function takeDoc(relationId, commonParams) {
            mrApiService.takeDoc(angular.extend({ relationIds: relationId }, commonParams)).then((data) => {
                localStorageService.set('resourceCenterMaterialInfo', JSON.stringify(data.datas));
                window.open( 
                    '#/fusionnews?iwoplatform=0&wzchannelid=2&wzsiteid=1&wzplatform=0&appchannelid=1&appsiteid=1&appplatform=0&newspapertype=2&paperid=4&issave=0&wxchannelid=3&wxplatform=0'
                );
            });
        }

    },
]);
